import { render, staticRenderFns } from "./participantBase.vue?vue&type=template&id=4dd4bcc6&scoped=true"
import script from "./participantBase.vue?vue&type=script&lang=js"
export * from "./participantBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd4bcc6",
  null
  
)

export default component.exports